<template lang="pug">
  transition(
  name="modal"
  )
    .modal-mask(
    @click="onClickMask($event)"
    )
      .modal-wrapper
        .modal.modal_achivement(
        @click="onClickWrapper($event)"
        )
          .modal__close
            button.modal-button-close(
              @click="onCloseModal($event)"
            )
              img(src="@/assets/images/icons/modal-button-close.svg")
          .modal__body
            .adding-achievement
              .adding-achievement__title
                h2.title {{ title }}
              .adding-achievement__form
                .adding-achievement-form.form
                  .form__elem
                    .form-elem(
                      :class="{ 'form-elem_error' : requireErrors.name }"
                    )
                      .form-elem__title Название
                      .form-elem__body
                        input.input.input_full(
                          v-on:keyup="keymonitor"
                          v-model="awardData.name"
                          :disabled="readOnly"
                        )
                  .form__elem
                    .form-elem(
                      :class="{ 'form-elem_error' : requireErrors.date }"
                    )
                      .form-elem__title Дата получения
                      .form-elem__body
                        date-picker(
                          placeholder="дд.мм.гггг"
                          v-model="awardData.date"
                          format="DD.MM.YYYY"
                          lang="ru"
                          @change="onChangeDate($event)"
                          :clearable="false"
                          :editable="true"
                          :not-after="new Date()"
                          :disabled="readOnly"
                        )
                  .form__elem
                    .form-elem(
                      :class="{ 'form-elem_error' : requireErrors.kind_of_activity }"
                    )
                      .form-elem__title Вид деятельности
                      .form-elem__body
                        simple-select-form(
                          :list-data="kindsOptions"
                          :default-value="defaultValues.kind_of_activity.text"
                          @onChangeDefaultValue="changeOptionValue"
                          type="kind_of_activity"
                          class="simple-select-form-1"
                          :read-only="readOnly"
                        )
                  .form__elem
                    .form-elem(
                      :class="{ 'form-elem_error' : requireErrors.type }"
                    )
                      .form-elem__title Тип достижения
                      .form-elem__body
                        simple-select-form(
                          :list-data="typeOptions"
                          :default-value="defaultValues.type.text"
                          @onChangeDefaultValue="changeOptionValue"
                          type="type"
                          class="simple-select-form-3"
                          :read-only="readOnly"
                        )

                  .form__elem
                    .form-elem(
                      :class="{ 'form-elem_error' : requireErrors.prize_place }"
                    )
                      .form-elem__title Призовое место
                      .form-elem__body
                        simple-select-form(
                          :list-data="prizeOptions"
                          :default-value="defaultValues.prize_place.text"
                          @onChangeDefaultValue="changeOptionValue"
                          type="prize_place"
                          class="simple-select-form-2"
                          :read-only="readOnly"
                        )

                  .form__elem
                    .form-elem
                      .form-elem__title Заочная олимпиада
                      .form-elem__body
                        label.checkbox
                          input.checkbox__input(
                            type="checkbox"
                            :checked="awardData.is_correspondence"
                            @change="onChangeCheckbox($event)"
                            :disabled="readOnly"
                          )
                          .checkbox__icon
                  .form__elem
                    .form-elem(
                      :class="{ 'form-elem_error' : requireErrors.link_to_event }"
                    )
                      .form-elem__title Ссылка на мероприятие
                      .form-elem__body
                        input.input.input_full(
                          placeholder="http://google.com"
                          type="url"
                          v-on:keyup="keymonitor"
                          v-model="awardData.link_to_event"
                          :disabled="readOnly"
                        )
                  .form__elem(
                    :class="{ 'form-elem_error' : requireErrors.attachments }"
                  )
                    attach-file(
                      :attachments="awardData.attachments"
                      attachment-type="file"
                      fieldname="'attachments'"
                      @onChangeAttachments="changeAttachments"
                      :keymonitor="keymonitor"
                      :read-only="readOnly"
                    )
                  .form__elem.adding-achievement-form__button(
                    v-if="!readOnly"
                  )
                    .form-elem__body
                      button.button.button_full.button_paint-main(
                        @click="onSaveAward($event)"
                      ) Сохранить
                  .form-elem__error(
                    v-show="showError"
                    style="float: right;"
                  ) Достижение не может быть старше 3-х лет
</template>

<script>
import {mapActions, mapState} from "vuex";

import AttachFile from "../attach-file/AttachFile";
import SimpleSelectForm from "@/components/simpleSelectForm/SimpleSelectForm.vue";
import DatePicker from "vue2-datepicker";

export default {
  name: "AchievementModal",
  components: {
    AttachFile,
    SimpleSelectForm,
    DatePicker
  },
  props: {
    defaultAward: {
      type: Object,
      default: () => ({})
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      showError: false,
      awardData: {
        name: "",
        date: "",
        kind_of_activity: null,
        prize_place: null,
        type: null,
        link_to_event: "",
        attachments: [],
        is_correspondence: false
      },
      requireErrors: {
        name: false,
        date: false,
        kind_of_activity: false,
        attachments: false,
        link_to_event: false,
        prize_place: false,
        type: false
      },
      defaultValues: {
        kind_of_activity: {
          text: "Выбрать",
          value: null
        },
        type: {
          text: "Выбрать",
          value: null
        },
        prize_place: {
          text: "Выбрать",
          value: null
        }
      }
    };
  },
  computed: {
    ...mapState(["catalogue"]),
    kindsOptions() {
      return this.catalogue.kinds_of_activities;
    },
    prizeOptions() {
      return this.catalogue.prize_places;
    },
    typeOptions() {
      return this.catalogue.portfolio_types;
    }
  },
  methods: {
    ...mapActions(["addAward", "updateAward"]),
    onChangeCheckbox(e) {
      this.awardData.is_correspondence = e.target.checked;
    },
    changeOptionValue(data, type) {
      this.defaultValues[type] = data;
      this.awardData[type] = data.value;
      this.keymonitor();
    },
    changeAttachments(data) {
      this.awardData.attachments = data.value;
      this.keymonitor();
    },
    keymonitor() {
      Object.keys(this.requireErrors).map(error => {
        this.requireErrors[error] = false;
        return error;
      });
      this.showError = false;
    },
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.stopPropagation();
    },
    onCloseModal(e) {
      if (e) {
        e.preventDefault();
      }
      this.$emit("close");
    },
    checkRequires() {
      const errors = [];
      if (this.awardData.name.length === 0) {
        errors.push("name");
      }
      if (this.awardData.date.length === 0) {
        errors.push("date");
      }
      if (this.awardData.kind_of_activity === null) {
        errors.push("kind_of_activity");
      }
      if (this.awardData.prize_place === null) {
        errors.push("prize_place");
      }
      if (this.awardData.type === null) {
        errors.push("type");
      }
      if (this.awardData.attachments.length === 0) {
        errors.push("attachments");
      }
      // if (this.awardData.link_to_event.length === 0) {
      //   errors.push("link_to_event");
      // }
      // if (this.awardData.link_to_event.length > 0) {
      //   const reg = /^((ftp|http|https):\/\/)?([A-zА-я]+)\.([A-zА-я]{2,})/;
      //   if (!reg.test(this.awardData.link_to_event)) {
      //     errors.push("link_to_event");
      //   }
      // }
      errors.map(error => {
        this.requireErrors[error] = true;
        return error;
      });
      return errors.length > 0;
    },
    onSaveAward(e) {
      e.preventDefault();
      if (this.checkRequires()) {
        return;
      }
      const awardData = JSON.parse(JSON.stringify(this.awardData));
      awardData.attachments = awardData.attachments.map(el => el.id);
      if (awardData.id) {
        this.updateAward(awardData).then(res => {
          if (res.status === 200) {
            this.onCloseModal();
            this.$emit("onAddAward", res.data);
          }
          if (res.status === 400 && res.data.date) {
            this.requireErrors.date = true;
            this.showError = true;
          }
          if (res.status === 400) {
            this.onCloseModal();
            this.$root.$emit("onShowNotificationModal", {
              text:
                "Вы не можете изменять награды, используемые в действующих заявках"
            });
          }
        });
      } else {
        this.addAward(awardData).then(res => {
          if (res.status === 201) {
            this.onCloseModal();
            this.$emit("onAddAward", res.data);
          }
          if (res.status === 400 && res.data.date) {
            this.requireErrors.date = true;
            this.showError = true;
          }
        });
      }
    },
    onChangeDate(date) {
      const d = new Date(date);
      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
        -2
      )}-${("0" + d.getDate()).slice(-2)}`;
      this.awardData.date = _date;
    }
  },
  mounted() {
    if (this.defaultAward.id) {
      const awardData = JSON.parse(JSON.stringify(this.defaultAward));
      // const date = awardData.date.split("-");
      // awardData.date = `${date[2]}.${date[1]}.${date[0]}`;
      this.defaultValues.kind_of_activity = this.kindsOptions.find(
        el => el.value === awardData.kind_of_activity.toString()
      );
      awardData.kind_of_activity = this.defaultValues.kind_of_activity.value;
      this.defaultValues.prize_place = this.prizeOptions.find(
        el => el.value === awardData.prize_place.toString()
      );
      awardData.prize_place = this.defaultValues.prize_place.value;
      this.defaultValues.type = this.typeOptions.find(
        el => el.value === awardData.type.id.toString()
      );
      awardData.type = this.defaultValues.type.value;
      this.awardData = awardData;
    } else {
      this.awardData = {
        name: "",
        date: "",
        kind_of_activity: null,
        prize_place: null,
        type: null,
        link_to_event: "",
        attachments: [],
        is_correspondence: false
      };
    }
  }
};
</script>
